import { edpApiV1 } from './index';

type WidgetButton = { id: number; text: string; screenLink: string };
type WidgetImage = { id: number; filename: string; path: string; uri: string };
export type Widget = {
  id: number;
  title: string;
  screenLink: string;
  position: number;
  isDisplayed: boolean;
  button: WidgetButton | null;
  image: WidgetImage;
};

export type GetWidgetsResponse = { data: Array<Widget> };

export const widgetsApi = edpApiV1.injectEndpoints({
  endpoints: build => ({
    getWidgets: build.query<Array<Widget>, null>({
      query: () => ({ url: '/v1/admin/ui/mobile/widgets', method: 'GET' }),
      providesTags: ['ui/mobile/widgets'],
      transformResponse: (response: GetWidgetsResponse) => response.data,
    }),
    patchWidget: build.mutation<Widget, Pick<Widget, 'id' | 'isDisplayed'>>({
      query: ({ id, ...body }) => ({ url: `/v1/admin/ui/mobile/widgets/${id}`, method: 'PATCH', body }),
      invalidatesTags: ['ui/mobile/widgets'],
    }),
  }),
  overrideExisting: false,
});

export const { useGetWidgetsQuery, usePatchWidgetMutation } = widgetsApi;
